import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress the benign "ResizeObserver loop completed with undelivered notifications"
// dev-server overlay that fires from Recharts / dnd-kit measurement passes.
// (Chrome quirk — does not affect functionality; only muted in dev overlay.)
const ROErrRe = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (ROErrRe.test(e.message || "")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  if (ROErrRe.test((e.reason && e.reason.message) || "")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// ---- PWA service-worker registration -----------------------------------
// Register only in production builds. Registering in `yarn start`/CRA dev
// mode causes stale-cache infinite reload loops because HMR and SW don't
// play well together. In production (`yarn build`) it hosts /service-worker.js
// under the same origin, which is what Chromium requires for
// `beforeinstallprompt` to fire.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => {
        // Don't crash the app if registration fails — the app still works
        // fine, just without offline-shell caching.
        console.warn('SW registration failed:', err);
      });
  });
}
